<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <v-dialog
      v-model="dialogTransfertCarte"
      max-width="70%"
      persistent
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>
              Liste des rechargements de la carte {{ carte.identifiant }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-card style="width:100%">
              <v-card-text fluid grid-list-md>
                <h6>LISTE DES RECHARGEMENTS</h6>
                <v-divider class="mb-3"></v-divider>

                <!-- BTN AJOUT -->
                <v-layout row>
                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="text-xs-center">
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:100%"
                      >
                        <span class="subheading"> Total credité: </span>
                        <span class="title"> {{ mntCredit }} Fcfa </span>
                      </v-chip>
                    </v-card-text>
                  </v-flex>
                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="text-xs-center">
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:100%"
                      >
                        <span class="subheading">Total debité: </span>
                        <span class="title"> {{ mntDebit }} Fcfa </span>
                      </v-chip>
                    </v-card-text>
                  </v-flex>

                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="text-xs-center">
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:100%"
                      >
                        <span class="subheading">Solde de la carte: </span>
                        <span class="title"> 30 000 Fcfa </span>
                      </v-chip>
                    </v-card-text>
                  </v-flex>

                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="">
                      <v-chip
                        color="orange"
                        text-color="white"
                        style="font-size:18px"
                      >
                        <v-avatar class="orange darken-4">{{
                          nbTransfert
                        }}</v-avatar>
                        transfert(s)
                      </v-chip>
                    </v-card-text>
                  </v-flex>
                </v-layout>

                <div class="text-xs-right mb-3">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="modalAjoutTransfert()"
                      dark
                      >Recharger<v-icon right>playlist_add</v-icon></v-btn
                    >
                    Recharger une carte
                  </v-tooltip>

                  <!-- <v-tooltip top>
                            <v-btn :disabled="true"  slot="activator" color="orange"  @click.stop="imprimeRgtPDF()" >
                                Imprimer
                                <v-icon right > print</v-icon>
                            </v-btn>
                            Imprimer la liste des transferts
                        </v-tooltip> -->
                </div>

                <div class="text-xs-left  mb-1 ">
                  <el-select
                    clearable
                    @clear="clearSelect()"
                    @change="filtrerTypeRecharge"
                    v-model="selectTypeRecharge"
                    placeholder="Type de rechargement"
                  >
                    <el-option
                      v-for="item in transferts"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    clearable
                    @clear="clearSelect()"
                    @change="filtrerType"
                    v-model="selectType"
                    placeholder="Type"
                  >
                    <el-option
                      v-for="item in transferts"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>

                <data-tables :data="transferts">
                  <el-table-column prop="dateRechargeFormat" label="date">
                  </el-table-column>
                  <el-table-column prop="type" label="Type"></el-table-column>
                  <el-table-column prop="typeTransfert" label="Type transfert">
                    <template slot-scope="scope">
                      <el-tag
                        :type="
                          scope.row.typeTransfert == 'débit'
                            ? 'danger'
                            : 'success'
                        "
                      >
                        {{ scope.row.typeTransfert }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="carteSource" label="Carte de recharge">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.carteSource" type="danger">
                        {{ scope.row.carteSource }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="carteCible" label="Carte rechargée">
                    <template slot-scope="scope">
                      <el-tag type="success">
                        {{ scope.row.carteCible }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="montantFormat" label="Montant (Fcfa)">
                    <template slot-scope="scope">
                      <el-tag> {{ scope.row.montantFormat }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column label="Action" align="center" fixed="right">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="modalEditTransfert(scope.row)"
                          fab
                          dark
                          small
                          color="primary"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Editer
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="showDialogSupp(scope.row)"
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </data-tables>
              </v-card-text>
            </v-card>
          </v-layout>

          <!-- MODAL SUPPRESSION DEMANDE -->
          <v-dialog v-model="dialogSupr" persistent max-width="50%">
            <v-card>
              <v-card-title class="headline"
                >Supprimer cet enregistrement ?</v-card-title
              >
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 class="mb-2">
                    <el-alert
                      title="La suppression est définitive"
                      :closable="false"
                      show-icon
                      type="error"
                    >
                    </el-alert>
                  </v-flex>
                  <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">
                      RECHARGEMENTS
                    </p>
                    <p class="black--text .font-weight-regular subheading">
                      ID-{{ idTransfert }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click="dialogSupr = false"
                  >Annuler <v-icon right>remove_circle</v-icon></v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteRecharge()"
                  >Supprimer <v-icon right>delete</v-icon></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- MODAL SUPPRESSION DEMANDE -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Ajout transfert -->
    <AjoutTransfertCarte
      :editRecharge="editTransfert"
      :carte="carte"
      :show="showModalAjoutTransfert"
      @close="
        showModalAjoutTransfert = false;
        loadTransfert();
      "
    ></AjoutTransfertCarte>
    -->
    <!-- Ajout transfert -->
  </div>
</template>

<script>
import AjoutTransfertCarte from "./AjoutTransfertCarte";

import Loading from "@/components/Loading";
export default {
  components: { Loading, AjoutTransfertCarte },
  name: "TransfertCarteIndex",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    carte: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      transferts: [],
      oldTransferts: [],
      dialogSupr: false,
      dialogTransfertCarte: false,
      selectTransfert: "",
      editTransfert: {},
      idTransfert: null,
      mntTotal: 0,

      showModalAjoutTransfert: false,
      nbTransfert: 0,
      selectType: "",
      selectTypeRecharge: "",
      mntCredit: 0,
      mntDebit: 0
    };
  },

  watch: {
    show: function(newValue, oldValue) {
      this.dialogTransfertCarte = newValue;
      if (newValue == true) {
        this.loadTransfert();
      }
    }
  },

  methods: {
    showDialogSupp(item) {
      this.idTransfert = item.id;
      this.dialogSupr = true;
    },

    deleteTransfert(rgt) {
      this.idRgt = rgt.id;
      this.dialogSupr = true;
    },
    closeDialog() {
      this.$emit("close");
    },

    modalAjoutTransfert() {
      this.editTransfert = {};
      this.showModalAjoutTransfert = true;
    },

    modalEditTransfert(transfert) {
      this.editTransfert = transfert;
      this.showModalAjoutTransfert = true;
    },

    imprimetransfertPDF() {
      let tab = [];
      this.transferts.forEach(function(transfert) {
        tab.push(transfert.id);
      });

      let url =
        this.domaine + "carteCarburant/reglement/imprimerPDF/liste/" + tab;
      window.open(url);
    },

    deleteRecharge() {
      this.loading = true;
      let url =
        this.domaine + "carteCarburant/delete/recharge/" + this.idTransfert;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION",
            message: "Le rechargement a été supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;

          this.loadTransfert();
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression du rechargement a échouée.",
            position: "top-center"
          });
        }
      );
    },

    clearSelect() {
      this.transferts = this.oldtransferts;
    },

    filtrerTypeRecharge(idtransfert) {},
    filtrerType(idtype) {},
    loadTransfert() {
      //this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      let url =
        this.domaine + "carteCarburant/transfert/carte/" + this.carte.carteId;

      this.$http.get(url).then(
        response => {
          //this.loading = false;
          // this.mntTTC =  response.body.mntTTC
          this.transferts = response.body.transferts;
          this.oldtransferts = response.body.transferts;
          this.nbTransfert = this.transferts.length;

          this.mntTotal = response.body.montantTotalFormat;
          this.mntCredit = response.body.montantCreditFormat;
          this.mntDebit = response.body.montantDebitFormat;
          //affichage nombre de demande
          if (response.body.transferts > 0) {
            this.nbtransfert = this.transferts.length;
          }
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des transferts"
          );
        }
      );
    }
  },

  mounted() {
    //this.loadReglement();
  }
};
</script>

<style scoped>
.toolbar_content {
  height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/TransfertCarteIndex.vue